module.exports = __webpack_public_path__ + "img/info-black-24-dp-3.9c4751dd.svg";